import { gql } from '@apollo/client'

export const CONFIRM_ATTEND_EVENT = gql`
    mutation updateAttendEventState($input: updateAttendEventStateInput!) {
        updateAttendEventState(input: $input) {
            entity {
                guid
            }
        }
    }
`
